import { GlobalClassInstance } from "@commoncore/constants/GlobalClass";
import { CustomSortService } from "@commoncore/services/custom-sort.service";
import { TeamFolderService } from "@commoncore/services/team-folder.service";
import { MultiSelectLibrary } from "@commoncore/utils/MultiSelectUtil";
import { AppEvents } from "@commoncore/utils/app-events";
import { ENV_CONSTANTS } from "@env-properties/environment";
import { ENV_CONFIG } from "@env-properties/environment-config";
import { FoldersViewImplementation } from "./FoldersViewImplementation";
import { ListViewImplementation } from "./ListViewImplementation";

export class TeamFoldersImplementation {

    public http : any;
    public globalService : any;
    public universalService: any;
    static singleInstance:any = null;
    localStorageService:any;
    listService:any;
    containerHeightCalc:any;
    customMetadata: any;
    listImpl: ListViewImplementation;
    tfsNextLink = "";
    tfsListSize: any = 0;
    tfsPreviousLink = "";
    multiSelect: MultiSelectLibrary;
    customSort: any;
    shareAccessService:any;
    foldersViewImpl: any;
    sortOrder: any;
    router:any;
    teamFolderService: any;
    public currentPageNo = 0;
    public previousPageNo = -1;
    paginationService: any;
    public resizeableObjectList = []; // it is used only for resize window frame - do not overwrite or use.
    sessionStorageService:any;
    constructor(globalService){
      this.globalService=globalService;
    }

    public setHandler(globalService) {
      this.http = globalService.getHttpClientRef();
      this.universalService = globalService.getUniversalServiceRef();
      this.localStorageService = globalService.getLocalStorageSvcRef();
      this.listService = globalService.getListServiceRef();
      this.customMetadata = globalService.getCustomMetadataServiceRef();
      this.containerHeightCalc = globalService.getContainerHeightCalculatorService();
      this.listImpl = ListViewImplementation.getInstance(globalService);
      this.foldersViewImpl = FoldersViewImplementation.getInstance(this.globalService);
      this.multiSelect = MultiSelectLibrary.getInstance(globalService);
      this.customSort = new CustomSortService(this.universalService);
      this.shareAccessService = globalService.getShareAccessServiceRef();
      this.router = globalService.getRouterRef();
      this.teamFolderService = new TeamFolderService();
      this.paginationService = globalService.getPaginationServiceRef();
      this.sessionStorageService = this.globalService.getSessionStorageSvcRef();
    }

    public static getInstance(globalService):TeamFoldersImplementation{
      if(this.singleInstance == null){
        this.singleInstance = new TeamFoldersImplementation(globalService);
        return this.singleInstance;
      }else{
        return this.singleInstance;
      }
    }

    updateAllFilesData(obj) {
      let objectsList = [];
      objectsList.push(obj);
      let tfcustomMetadata = this.teamFolderService.setCustomMetadataForTeamFolders(objectsList);
      let response = this.customMetadata.segregateData(tfcustomMetadata, 'allfiles');
      this.universalService.showSortButtons = true;
      if (this.universalService.nameSort) {
        let sortedData = this.customSort.sortByNames(response, this.universalService.sortByNameArray);
        this.universalService.sortByNameArray = sortedData[0];
        AppEvents.virtualDOMObservable.next({"updateVDOM":true,"action":"upload",'object':obj,"uploadDetails":sortedData[2],sortType:'name','foldersArray':this.universalService.foldersArray,'sortedArray':this.universalService.sortByNameArray})
        AppEvents.multiSelectEvent.next({"dataArray":this.universalService.sortByNameArray})
      } else {
        let sortedData = this.customSort.sortByDates(response, this.universalService.sortByDateArray, this.universalService.sharedRoot, "createdDate",true);
        this.universalService.sortByDateArray = sortedData[0]
        AppEvents.virtualDOMObservable.next({"updateVDOM":true,"action":"upload",'object':obj,"uploadDetails":sortedData[2],sortType:'date','foldersArray':this.universalService.foldersArray,'sortedArray':this.universalService.sortByDateArray})
        AppEvents.multiSelectEvent.next({"dataArray":this.universalService.sortByDateArray})
      }
      this.universalService.emptyTab = false;
      this.universalService.emptyFolder = false;
    }

    updateListView(obj) {
      let objArray = [obj];
      this.universalService.emptyTab = false;
      this.universalService.emptyFolder = false;
      this.universalService.showSortButtons = true;
      setTimeout(() => {
        this.listImpl.updateListViewData(objArray);
      }, 100);
    }

    setRootTeamFolderDataAsPerView(objects,appendToExistingList=false){
      this.resizeableObjectList = objects;
      let tfcustomMetadata = this.teamFolderService.setCustomMetadataForTeamFolders(objects,true);
      let teamFoldersCustomMetadata = this.customMetadata.segregateData(tfcustomMetadata, 'allfiles');
      this.tfsListSize = this.tfsListSize + objects.length;
      if(!this.router.url.includes("home")){
        if(!this.universalService.isMobileDevice) { 
          setTimeout(() => {
              this.listImpl.decideListOptions("teamfolders");
              this.listImpl.fetchTeamFoldersListView(teamFoldersCustomMetadata);
          }, 100);
        }
        else{
          this.multiSelect.bindMultiSelectLibrary("#teamFolderWrapperId", "list_info", ".listItem:visible", false,this.universalService.virtualGridEnabled,false);
        }
        this.setHeightForView();
      }
    }
    setTeamFolderContentDataAsPerView(arr,type=""){
      this.resizeableObjectList = arr;
      this.universalService.emptyFolder = false;
      this.universalService.emptyTab = false;
      if(type != "foldersOnly" && (!arr || arr.length==0 && this.universalService.foldersArray?.length == 0)){
        this.universalService.emptyFolder = true;
        this.universalService.showLoader = false;
      }
      let tfcustomMetadata = this.teamFolderService.setCustomMetadataForTeamFolders(arr);
      let teamFoldersContentCustomMetadata = this.customMetadata.segregateData(tfcustomMetadata, 'allfiles');
      this.tfsListSize = this.tfsListSize + arr.length;
      if(this.universalService.listView && !this.universalService.isMobileDevice && !this.universalService.emptyFolder){
        this.listImpl.decideListOptions('teamfoldercontent');
        this.listImpl.fetchTeamFoldersContentListView(teamFoldersContentCustomMetadata);
      }
      else{
        // setDataforGridView
        if(this.universalService.nameSort){
          this.sortByName(teamFoldersContentCustomMetadata);
          // if(this.universalService.showJustifiedLayout){
          //   this.decideOnJustifiedView(true);
          // }
        }else{
          this.sortByDate(teamFoldersContentCustomMetadata);
          // if(this.universalService.showJustifiedLayout){
          //   this.decideOnJustifiedView(false);
          // }
        }
        this.multiSelect = MultiSelectLibrary.getInstance(this.globalService);
        if(this.universalService.listView && this.universalService.isMobileDevice) {
          this.multiSelect.bindMultiSelectLibrary("#teamfolderWrapperID", "list_info", ".listItem:visible", false,this.universalService.virtualGridEnabled,false);
          this.multiSelect.bindMultiSelectUIevent(".main-wrapper", ".list_file_child");
        } else {
          setTimeout(() => {  
            this.multiSelect.bindMultiSelectLibrary(".allFilesWrapper", "grid_info", ".gridItem:visible", true,this.universalService.virtualGridEnabled,false);
            this.multiSelect.bindMultiSelectUIevent(".tab-content", ".grid_file_child");  
          }, 100);
        }
      }
      this.setHeightForView();
    }

    getAllTeamFoldersUser(url){
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.get(url).subscribe(
            resp => {
              self.universalService.foldersArray = [];
              self.tfsNextLink = "";
              self.tfsPreviousLink = "";
              self.universalService.totalTfCount = resp["totalTfCount"] ? resp["totalTfCount"] : 0;
              self.paginationService.spliceAndSaveDataInLocalDB(resp["objects"]);
              self.setNextLink(resp);
              self.setRootTeamFolderDataAsPerView(self.paginationService.getBufferDataForNextPage(self.currentPageNo));
              self.paginationService.deleteLocalBufferOnceThePageIsViewed(self.currentPageNo)
              self.universalService.foldersArray = resp["objects"];
              self.universalService.showLoader = false;
              resolve(resp["objects"]);
            },
            err => {
               self.universalService.showLoader = false;
               reject(err);
            }
         )
      })
    }

    setNextLink(resp){
      if(resp["nextLink"]){
        this.tfsNextLink = resp["nextLink"]// + this.sortOrder;
        if (this.tfsNextLink.includes("sort=")) {
          if (this.tfsNextLink.includes("sort=+")) {
            this.tfsNextLink=this.tfsNextLink.replace("sort=+", "sort=%2B")
          }else if (this.tfsNextLink.includes("sort=-")) {
            this.tfsNextLink=this.tfsNextLink.replace("sort=-", "sort=%2D")
          }
        }
      }else{ 
        this.tfsNextLink = "";
      }
    }

    resetValues(){
      this.universalService.emptyTab = true;
      this.tfsNextLink = "";
      this.tfsPreviousLink = "";
      this.currentPageNo = 0;
      this.previousPageNo = -1;
      this.paginationService.LOCAL_DB = {}
      this.universalService.mobileSelectedObj = [];
      let sortingType =  this.universalService.sharePublicSortSetting();
      this.sessionStorageService.setSharePublicSortPropName(sortingType);
      this.universalService.objectsPreviewArray = [];
      this.tfsListSize = 0;
      this.universalService.scrollToTopIcon = false;
    }

    decideSortOrder(url){
      // this.resetValues();
      this.currentPageNo = 0;
      this.previousPageNo = -1;
      this.paginationService.LOCAL_DB = {}
      this.universalService.shareViewTypeSetting();


      
      if(!this.universalService.listView || (this.universalService.listView && this.universalService.isMobileDevice)) {
          if (localStorage.sharePublicSort == this.universalService.sharePublicSortByDate) {
            this.universalService.nameSort = false;
            this.sortOrder=this.listService.listViewSortOrder;
          } else {
            this.universalService.nameSort = true;
            this.sortOrder='&sort=%2BobjectName';
          }
        }else{
          this.sortOrder = this.listService.listViewSortOrder;
        }
        if(!this.sortOrder.includes('&sort=')){
          this.sortOrder = '&sort=' + this.sortOrder;
        }
        return url   = url + this.sortOrder;
        
  
    }

    getCurrentTeamFolderContent(url,type="") {
      url = this.decideSortOrder(url);
      var self = this;
      return new Promise(function (resolve, reject) {
         self.http.get(url).subscribe(
          resp => { 
            if(type == "foldersOnly" && !self.universalService.virtualGridEnabled){
              self.setNextLink(resp);
              self.setTeamFolderContentDataAsPerView(resp["objects"],type);
            }else{
              self.tfsListSize = 0;
              self.paginationService.spliceAndSaveDataInLocalDB(resp["objects"]);
              self.handleNextLinkToGetFilesAfterFolder(url, resp);
              self.setNextLink(resp);
              self.setTeamFolderContentDataAsPerView(self.paginationService.getBufferDataForNextPage(self.currentPageNo),type);
              self.paginationService.deleteLocalBufferOnceThePageIsViewed(self.currentPageNo)
            }
            resolve(resp["objects"]);
          },
          error => {
            self.universalService.showErrorMessage(error);
            self.universalService.isServerError = false;
            reject(error);
          }
        )
      });
    }
          
    async handleNextLinkToGetFilesAfterFolder(url,resp) {
      if(resp && (resp["nextLink"] == "" || resp["nextLink"] == undefined) && url.includes("type=w")) {
        var tfFilesUrl = new URL(url).searchParams;
        tfFilesUrl.delete("pageRefId");
        tfFilesUrl.delete("page");
        tfFilesUrl.set("type","f");
        tfFilesUrl.set("limit",(ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"]).toString());
        let newUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["nonadminTeamFolderMetadataOptimised"] + "?" + tfFilesUrl;
        await this.getNextPageData(newUrl,true);
      }
    }
    
    
    createUrlForNextLinkOnDesktop(url) {
          
      if (this.listService.listOptions.api.getVerticalPixelRange().top == 0)
        this.universalService.scrollToTopIcon = false;
      else
        this.universalService.scrollToTopIcon = true;
      
      if(this.tfsListSize - this.listService.listOptions.api.getLastDisplayedRow() < 3 && this.previousPageNo != this.currentPageNo && this.paginationService.LOCAL_DB[this.currentPageNo + 1] && this.paginationService.LOCAL_DB[this.currentPageNo + 1].length != 0){
        this.previousPageNo = this.currentPageNo;
        setTimeout(async () => { // timeout is added to restrict fetching data for multiple pages back to back as the scroll event is fired multiple times
          this.currentPageNo ++;
          let objList = await this.paginationService.getBufferDataForNextPage(this.currentPageNo);
          if(this.router.url.includes('/teamfolders/')){
            this.appendTeamFolderContentData(objList);
          }else{
            this.appendTeamFolderRootData(objList);
          }
          this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo)
        }, this.paginationService.bufferTimeoutForFetchingData);
      }

      if (this.tfsListSize - this.listService.listOptions.api.getLastDisplayedRow() < 3) {
        //  url = this.tfsNextLink
        if ((this.tfsPreviousLink != this.tfsNextLink)) {
          this.tfsPreviousLink = this.tfsNextLink
          if (this.tfsNextLink != "") {
            this.universalService.showLoader = true;
            this.getNextPageData(url);
          }
        }
      }
    }

    createUrlForNextLink(docheight,toppos,url,containerName){
      if(toppos == 0){
        this.universalService.scrollToTopIcon = false;
      }else{
        this.universalService.scrollToTopIcon = true;
        let checkIfContaineris95PercScrolled = this.universalService.virtualGridEnabled ? true : ($('.scrollableContainer').scrollTop() + $(containerName).innerHeight()) >= (0.95 * docheight);
        if(checkIfContaineris95PercScrolled && this.previousPageNo != this.currentPageNo && this.paginationService.LOCAL_DB[this.currentPageNo + 1] && this.paginationService.LOCAL_DB[this.currentPageNo + 1].length != 0){
          this.previousPageNo = this.currentPageNo;
          setTimeout(async () => { // timeout is added to restrict fetching data for multiple pages back to back as the scroll event is fired multiple times
            this.currentPageNo ++;
            let objList = await this.paginationService.getBufferDataForNextPage(this.currentPageNo);
            if(this.router.url.includes('/teamfolders/')){
              this.appendTeamFolderContentData(objList);
            }else{
              this.appendTeamFolderRootData(objList);
            }
            this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo)
          }, this.paginationService.bufferTimeoutForFetchingData);
        }
        if( checkIfContaineris95PercScrolled && this.tfsNextLink != "" && this.tfsPreviousLink != this.tfsNextLink){
          this.tfsPreviousLink = this.tfsNextLink;
          this.universalService.showLoader = true;
          this.getNextPageData(url);
        }
      }
  }

    getNextPageData(url,firstfilescall=false) {
      var self = this;
      return new Promise(function (resolve, reject) {
        self.http.get(url).subscribe(
           async resp => {
              if(resp["objects"] && (firstfilescall || !self.paginationService.LOCAL_DB[self.currentPageNo])){ // this condition is added when user has scrolled all the buffer data, there is no buffer data left and API call is taking time or due to network latency to return data, post API response we are populating the data
                let bufferDataPresent = self.paginationService.checkIfBufferDataIsPresent();
                if(!bufferDataPresent){
                  self.currentPageNo = Object.keys(self.paginationService.LOCAL_DB).length;
                  self.previousPageNo = self.currentPageNo - 1;
                  self.paginationService.spliceAndSaveDataInLocalDB(resp["objects"]);
                  self.setNextLink(resp);
                  self.handleNextLinkToGetFilesAfterFolder(url, resp);
                  let objList = await self.paginationService.getBufferDataForNextPage(self.currentPageNo);
                  if(self.router.url.includes('/teamfolders/')){
                    self.appendTeamFolderContentData(objList);
                  }else{
                    self.appendTeamFolderRootData(objList);
                  }
                  self.paginationService.deleteLocalBufferOnceThePageIsViewed(self.currentPageNo);
                  resolve(resp);
                  return;
                }
              }
              self.universalService.showLoader = false;
              self.paginationService.spliceAndSaveDataInLocalDB(resp["objects"]);
              self.handleNextLinkToGetFilesAfterFolder(url, resp);
              self.setNextLink(resp);
              resolve(resp);
           },
           async err => {
              reject(err);
           }
        )
     })
    }

    async appendTeamFolderContentData(objectsList){
      this.resizeableObjectList = this.resizeableObjectList.concat(objectsList);
      let tfcustomMetadata = this.teamFolderService.setCustomMetadataForTeamFolders(objectsList);
      let teamFoldersContentCustomMetadata = this.customMetadata.segregateData(tfcustomMetadata, 'allfiles');
      this.tfsListSize = this.tfsListSize + objectsList.length;
      if(this.universalService.listView){
        if(this.universalService.isMobileDevice){
          this.universalService.foldersArray = this.universalService.foldersArray.concat(teamFoldersContentCustomMetadata);
          this.universalService.showLoader = false;
        }
        else {
          this.listImpl.fetchTeamFoldersContentListView(teamFoldersContentCustomMetadata,true);
        }
      }
      else{
        if(this.universalService.nameSort){
          this.sortByName(teamFoldersContentCustomMetadata);
        }else{
          this.sortByDate(teamFoldersContentCustomMetadata);
        }
      }
      this.setHeightForView();
    }

    sortByDate(allFiles) {
         
      var array  = this.customSort.sortByDates(allFiles,this.universalService.sortByDateArray,this.universalService.sharedRoot,"createdDate")
      this.universalService.sortByDateArray = array[0];
      this.universalService.objectsPreviewArray = array[1];
      this.universalService.loadGridView = true;
      if(this.universalService.sortByDateArray.length == 0 && this.universalService.foldersArray.length == 0){
        this.universalService.emptyTab = true;
        this.universalService.emptyFolder = true;
        this.universalService.showLoader = false;
        this.universalService.showSortButtons = false;
        return
      }else{
        this.universalService.emptyTab = false;
        this.universalService.emptyFolder = false;
        this.universalService.showSortButtons = true;
      }
      setTimeout(() => {
        this.universalService.showLoader = false;  
      }, 10);
      AppEvents.virtualDOMObservable.next({"updateVDOM":true})
      AppEvents.multiSelectEvent.next({"dataArray":this.universalService.sortByDateArray.concat(this.universalService.foldersArray)})
    }



    sortByName(allFiles){
      var array  = this.customSort.sortByNames(allFiles,this.universalService.sortByNameArray)
      this.universalService.sortByNameArray = array[0];
      this.universalService.objectsPreviewArray = array[1];
      this.universalService.loadGridView = true;
      if(this.universalService.sortByNameArray.length == 0 && this.universalService.foldersArray.length == 0){
        this.universalService.emptyTab = true;
        this.universalService.emptyFolder = true;
        this.universalService.showLoader = false;
        this.universalService.showSortButtons = false;
        return
      }else{
        this.universalService.emptyFolder = false;
        this.universalService.emptyTab = false;
        this.universalService.showSortButtons = true;
      }
      setTimeout(() => {
        this.universalService.showLoader = false;  
        if(this.universalService.isViewFileClicked == true) {
          this.universalService.isViewFileClicked == false;
          document.getElementsByClassName('list_info')[0].scrollIntoView();
        }
      }, 10);
      AppEvents.virtualDOMObservable.next({"updateVDOM":true})
      AppEvents.multiSelectEvent.next({"dataArray":this.universalService.sortByNameArray.concat(this.universalService.foldersArray)})
    }

    async appendTeamFolderRootData(objectsList){
      this.resizeableObjectList = this.resizeableObjectList.concat(objectsList);
      let tfcustomMetadata = this.teamFolderService.setCustomMetadataForTeamFolders(objectsList,true);
      let teamFoldersCustomMetadata = this.customMetadata.segregateData(tfcustomMetadata, 'allfiles');
      this.tfsListSize = this.tfsListSize + objectsList.length;
      if(this.universalService.isMobileDevice){
        this.universalService.foldersArray = this.universalService.foldersArray.concat(teamFoldersCustomMetadata);
        this.universalService.showLoader = false;
      }
      else {
        this.listImpl.fetchTeamFoldersListView(teamFoldersCustomMetadata,true);
      }
      this.setHeightForView();
    }

    setHeightForView(){
      var self = this;
      this.setHeightForContainer();
      $(window).resize(function () {
        self.setHeightForContainer();
      });
    }

    setHeightForContainer(){

      var collapsedHeight = $('#m-collapsed-modal .modal-content').height();
      collapsedHeight = collapsedHeight?collapsedHeight:0
      if(this.universalService.openFolderContent){
        if (!this.universalService.isMobileDevice) {
          if(this.universalService.virtualGridEnabled) return
          setTimeout(() => {
            this.containerHeightCalc.calculateHeight('#teamfolderWrapperID',['.pseudo-header','.pseudo-top-header','.pseudo-banner-container'],74);
          }, 100);
        }else {
          if(this.universalService.virtualGridEnabled) return;
          setTimeout(() => {
            this.containerHeightCalc.calculateHeight('.scrollableContainer',['.pseudo-mobile-header','.pseudo-tab','.pseudo-banner-container', '.pseudo-audiominiplayer'],(67 + collapsedHeight))
          }, 500);
        }    
      }
      else{
        if(!this.universalService.isMobileDevice && window.location.href.includes('/teamfolders')){
          this.containerHeightCalc.calculateHeight('.tab-content #ag-grid',['.pseudo-header','.pseudo-top-header','.pseudo-tab','.pseudo-banner-container', '.pseudo-audiominiplayer'],0)
        }
        else{
          if(this.universalService.virtualGridEnabled) return
          this.containerHeightCalc.calculateHeight('.scrollableContainer',['.pseudo-mobile-header','.pseudo-tab','.pseudo-banner-container', '.pseudo-audiominiplayer'],(67 + collapsedHeight))
        }
      }   
    }

    selectAll(event){
      this.listImpl.selectAll(event)
    }


    updateUIListView(executedTask,data){
      if(executedTask == "LEAVETEAMFOLDER"){
        var res = this.listService.listOptions.api.applyTransaction({ remove: data });
        this.listService.deSelectAll();
      }
    }


    updateTheUIMobileView(executedTask,data){
      if(executedTask == "LEAVETEAMFOLDER"){
        var indexOfLeavingTeamFolder = this.universalService.foldersArray.indexOf(data[0]);
        if(indexOfLeavingTeamFolder >= 0){
          this.universalService.foldersArray.splice(indexOfLeavingTeamFolder,1);
        }
        this.listService.deSelectAll();
        return this.universalService.foldersArray;
      }
    }

    initializeAgGridForIfUploadedInEmptyView(){
      this.listImpl.initializeAgGridForIfUploadedInEmptyView('teamfoldercontent');
    }

}
